import { useEffect, useState } from "react";
import styles from "./CompanyMap.module.css";

import "ol/ol.css";
import { Map, View } from "ol";
import { Style, Icon, Fill, Stroke, Text } from "ol/style";
import KSIC from "../../img/company_map_marker.png";

import { defaults as defaultControls } from "ol/control";

import Projection from "ol/proj/Projection";

import TileLayer from "ol/layer/Tile";
import TileImage from "ol/source/TileImage";
import TileGrid from "ol/tilegrid/TileGrid";

import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";

/**
 * @author yjkim
 * @date 2022-10-05 09:48:23
 * @remark 회사소개 페이지 회사 지도
 * @function loadCompanyMap() OpenLayers+바로e맵 로드 함수
 * @returns <CompanyMap>
 */

const companyStyle = new Style({
    image: new Icon({
        scale: 0.1,
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: KSIC,
    }),
    text: new Text({
        text: "(주)한국공간정보통신",
        offsetY: -65,
        font: "14px NotoSansR",
        fill: new Fill({
            color: "black",
        }),
        backgroundFill: new Fill({
            color: "white",
        }),
        backgroundStroke: new Stroke({
            color: "black",
        }),
        padding: [4, 2, 2, 2],
        justify: "center",
        overflow: true,
    }),
});

const createNGIImap = () => {
    const wmts_url = "https://map.ngii.go.kr/openapi/Gettile.do?";
    const wmts_options = "service=WMTS&request=GetTile&version=1.0.0&layer=base_hd&style=korean&format=image/png&tilematrixset=korean";

    const matrixIds = ["L05", "L06", "L07", "L08", "L09", "L10", "L11", "L12", "L13", "L14", "L15", "L16", "L17", "L18"];

    const maxResolution = 2088.96;
    let resolutions = [];

    for (let i = 0; i < 14; i++) {
        resolutions.push(maxResolution / Math.pow(2, i));
    }

    const NGIImap = new TileLayer({
        source: new TileImage({
            crossOrigin: "anonymous",
            tileGrid: new TileGrid({
                extent: [-200000.0, -3015.4524155292, 3803015.45241553, 4000000.0],
                origin: [-200000.0, 4000000.0],
                tileSize: [256, 256],
                resolutions: resolutions,
            }),
            tileUrlFunction: function ([level, col, row]) {
                return (
                    wmts_url +
                    wmts_options +
                    "&tilematrix=" +
                    matrixIds[level] +
                    "&tilecol=" +
                    col +
                    "&tilerow=" +
                    row +
                    "&apikey=1CAC05CD9FB7CA048DC4ED05A120599B"
                );
            },
        }),
        visible: true,
    });

    return NGIImap;
};

export function CompanyMap(props: any) {
    useEffect(() => {
        const extent = [90112, 1192896, 1990673, 2761664];

        const projection = new Projection({
            code: "EPSG:5179",
            units: "m",
            extent: extent,
        });

        const ngiiLayer = createNGIImap();

        const companyCoordinate = [951546.2289798139, 1939602.4809315854];

        const companyLayer = new VectorLayer({
            source: new VectorSource({
                features: [
                    new Feature({
                        name: "company",
                        geometry: new Point(companyCoordinate),
                    }),
                ],
            }),
            style: companyStyle,
        });

        // Map 생성
        const map = new Map({
            controls: defaultControls({ zoom: false, rotate: false }).extend([]),
            layers: [ngiiLayer, companyLayer],
            target: "company_map",
            view: new View({
                projection: projection,
                center: companyCoordinate,
                zoom: 10,
                maxZoom: 16,
            }),
        });

        const resizeObserver = new ResizeObserver((entries) => {
            map.updateSize();
        });

        const mapElement = map.getTargetElement();
        resizeObserver.observe(mapElement);

        return () => {
            resizeObserver.unobserve(mapElement);
            map.setTarget(undefined);
        };
    }, []);

    return (
        <div className={styles.company_map_wrapper}>
            {/*회사지도*/}
            <div className={styles.company_map}>
                <div>
                    <p className={styles.company_map_text_bold}>찾아오시는 길</p>
                    <p className={styles.company_map_text_light}>서울특별시 관악구 관악로 1 에너지자원신기술연구소(135동) 410호</p>
                </div>
                <div className={styles.company_map_div}>
                    <div id="company_map" className={styles.company_map_view} />
                </div>
            </div>
        </div>
    );
}
